import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-radio" }
const _hoisted_2 = { class: "app-radio__item" }
const _hoisted_3 = ["name", "disabled", "checked"]

type radioProps = {
  modelValue: boolean | null;
  radioValue: boolean | null;
  name: string;
  disabled?: boolean;
  size?: "md" | "lg";
  text?: string;
};

type radioEmit = {
  "on-change": [event: object];
  "on-input": [value: boolean];
  input: [value: boolean];
};


export default /*@__PURE__*/_defineComponent({
  __name: 'AppRadioButton',
  props: {
    modelValue: { type: [Boolean, null] },
    radioValue: { type: [Boolean, null] },
    name: {},
    disabled: { type: Boolean },
    size: { default: "md" },
    text: { default: "Text" }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const onChange = () => {
  emit("update:modelValue", props.radioValue);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _createElementVNode("input", {
        class: "app-radio__core",
        type: "radio",
        name: _ctx.name,
        disabled: _ctx.disabled,
        checked: _ctx.modelValue === _ctx.radioValue,
        onChange: onChange
      }, null, 40, _hoisted_3),
      _createElementVNode("div", {
        class: _normalizeClass({
          'app-radio__item-label': true,
          [`app-radio__item-label__${props.size}`]: true,
          'app-radio__item-label__disabled': props.disabled,
          // 'app-radio__item-label__disabled-checked':
          // 	props.disabled && props.value,
        })
      }, null, 2),
      _createElementVNode("span", {
        class: _normalizeClass({
          'app-radio__item-text': true,
          [`app-radio__item-text__${props.size}`]: true,
        })
      }, _toDisplayString(props.text), 3)
    ])
  ]))
}
}

})